import { Button } from "@/components/ui/button"
import { useAutoTranslation, useUserStore } from "@/entities"
import { DISCOVERED_TRANSLATION_KEYS, ROUTER_PATHS } from "@/shared/constants"
import { AlertTriangle } from "lucide-react"
import { Link } from "react-router-dom"

export const GuestModeBanner = () => {
  const isGuest = useUserStore(state => state.isGuest)
  const { t } = useAutoTranslation()

  if (!isGuest) return null

  return (
    <div className="flex min-h-11 items-center justify-center gap-3 border-b border-blue-200 bg-blue-50 px-4 py-1.5 text-sm text-blue-950 dark:border-blue-900 dark:bg-blue-950 dark:text-blue-100">
      <AlertTriangle className="size-4 shrink-0" aria-hidden="true" />
      <span>
        {t(DISCOVERED_TRANSLATION_KEYS.GUEST_ACCOUNT_WARNING)}
      </span>
      <Button asChild size="sm" className="h-7 shrink-0 bg-[#2066e8] px-3 text-white hover:bg-[#1857ca]">
        <Link to={ROUTER_PATHS.PROFILE_CONNECT_EMAIL}>
          {t(DISCOVERED_TRANSLATION_KEYS.CONNECT_EMAIL)}
        </Link>
      </Button>
    </div>
  )
}
